import { createClient } from '@supabase/supabase-js'
import { Platform } from 'react-native'

const SUPABASE_URL = process.env.EXPO_PUBLIC_SUPABASE_URL
const SUPABASE_ANON_KEY = process.env.EXPO_PUBLIC_SUPABASE_KEY

const authOptions = Platform.OS !== 'web'
  ? {
      storage: require('@react-native-async-storage/async-storage').default,
      persistSession: true,
      autoRefreshToken: true,
      storageKey: 'virtua-cycling-auth',
    }
  : {
      persistSession: true,
      autoRefreshToken: true,
      storageKey: 'virtua-cycling-auth',
    }

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: authOptions,
})